// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--d8645";
export var footer = "Footer-module--footer--519a5";
export var inner = "Footer-module--inner--f4821";
export var links = "Footer-module--links--37f40";